import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
let BackgroundPreloadService = class BackgroundPreloadService {
    constructor() {
    }
    preload(route, load) {
        if (route.data && route.data.preload) {
            return load();
        }
        else {
            return of(null);
        }
    }
    static ctorParameters = () => [];
};
BackgroundPreloadService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BackgroundPreloadService);
export { BackgroundPreloadService };
